import posthog from 'posthog-js';

const FeatureFlag = {
  INSIDE_SALES_ADMIN: 'InsideSalesAdmin',
  CRX_ADMIN: 'CRXAdmin',
  PRIMARY_COLOR: 'PrimaryColor',
  CLIENT_JOURNEY_WEEKLY_MESSAGE: 'clientJourneyWeeklyMessage',
  SMART_CONTEXT_SIDEBAR: 'smartContextSidebar',
};

const isFeatureEnabled = (featureFlag) => posthog.isFeatureEnabled(featureFlag);

const isCRXAdmin = () => isFeatureEnabled(FeatureFlag.CRX_ADMIN);

const isInsideSalesAdmin = () => isFeatureEnabled(FeatureFlag.INSIDE_SALES_ADMIN);

const isPrimaryColorEnabled = () => isFeatureEnabled(FeatureFlag.PRIMARY_COLOR);

const isClientJourneyWeeklyMessageEnabled = () => isFeatureEnabled(FeatureFlag.CLIENT_JOURNEY_WEEKLY_MESSAGE);

export {
  isInsideSalesAdmin,
  isCRXAdmin,
  isPrimaryColorEnabled,
  isClientJourneyWeeklyMessageEnabled,
  FeatureFlag,
};
